import ScrubstrApiQueryService, {
  ScrubstrApiQueryServiceGetEvent,
} from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export interface NewOrganization {
  id: number
  name: string
  city: string | null
  state: string
  address: string | null
  submissionNotes?: string | null
  submittedByEmail?: string | null
  createdAt: string
  updatedAt: string
}

export class NewOrganizationService {
  public async getNewOrganizations(isAgency: boolean): Promise<NewOrganization[]> {
    const scrubstrApiQueryRequest: ScrubstrApiQueryServiceGetEvent = {
      endpoint: 'get-new-organization',
      params: { isAgency: isAgency.toString() },
    }

    const scrubstrApiQueryService = new ScrubstrApiQueryService()
    const response = await scrubstrApiQueryService.get<{ data: NewOrganization[]; total: number }>(
      scrubstrApiQueryRequest,
    )

    return response.data
  }

  public async approveOrganization(
    organizationId: number,
    isAgency: boolean,
    changedProperties?: Record<string, string | number | boolean | null | undefined>,
  ): Promise<void> {
    const scrubstrApiQueryService = new ScrubstrApiQueryService()

    await scrubstrApiQueryService.post({
      endpoint: 'accept-requested-hospital-or-agency',
      data: {
        organizationId,
        isAgency,
        changedProperties,
      },
    })
  }

  public async rejectOrganization(organizationId: number, isAgency: boolean): Promise<void> {
    const scrubstrApiQueryService = new ScrubstrApiQueryService()

    await scrubstrApiQueryService.post({
      endpoint: 'reject-requested-hospital-or-agency',
      data: {
        organizationId,
        isAgency,
      },
    })
  }
}